import React from 'react';

const LegendPanel = ({ stablecoinPercentage, m2Percentage }) => {
  const legendItems = [
    {
      color: 'bg-primary',
      label: 'Stablecoins',
      percentage: stablecoinPercentage,
      description: 'Total stablecoin market cap as percentage of M2'
    },
    {
      color: 'bg-muted',
      label: 'Traditional M2',
      percentage: m2Percentage,
      description: 'Remaining traditional money supply'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">
        Legend
      </h3>
      <div className="space-y-3 md:space-y-4">
        {legendItems?.map((item, index) => (
          <div key={index} className="flex items-start gap-3">
            <div className={`w-6 h-6 md:w-8 md:h-8 ${item?.color} rounded flex-shrink-0 border-t border-b border-l border-r`} />
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2 mb-1">
                <span className="text-sm md:text-base font-medium text-foreground">
                  {item?.label}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LegendPanel;